<template>
    <v-container>
        <!-- avisos no topo da página -->
        <v-card class="cards">
            <v-card-title>
                {{'Aviso' | translate('Aviso')}}
            </v-card-title>
            <v-card-text>
                <v-row v-for="warning in warnings" :key="warning.position">
                    <v-col md="11" cols="12">
                        <v-text-field
                            autofocus
                            :loading="loading"
                            v-model="warning.TEXTO"
                            :label="labels.aviso"
                        ></v-text-field>
                    </v-col>
                    <v-col md="1" cols="12">
                        <v-btn
                            class="btn1"
                            dark
                            @click="deleteWarning(warning.position)"
                        > 
                            <v-icon x-small>
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="btn1"
                    dark
                    @click="addWarning"
                > 
                    <v-icon x-small>
                        mdi-plus
                    </v-icon>
                </v-btn>
                <v-spacer/>
                <v-btn
                    class="btn1"
                    dark
                    @click="save"
                > 
                    <v-icon x-small >
                        mdi-check
                    </v-icon>
                    <span style="margin-left: 4px;">{{'Salvar' | translate('Aviso')}}</span>
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- banners -->
        <v-card class="cards">
            <v-card-title>
                {{'Banner'}}
            </v-card-title>
            <v-card-text style="padding:15px;">
                <v-row>
                    <v-col md="11" cols="12">
                        <v-file-input
                            autofocus
                            :loading="loading"
                            :label="labels.banner"
                            v-model="newBanner"
                            accept=".png, .jpg"
                        ></v-file-input>
                    </v-col>
                    <v-col md="1" cols="12">
                        <v-btn
                            @click="uploadBanner()"
                            :disabled="!this.newBanner || !!this.registeredBanner.name"
                            class="btn1 white--text"
                            style="background-color:black;"
                        > 
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                
                <div v-if="this.registeredBanner.name" md="11" cols="12" style=" display:flex; margin-top:20px;" class="registeredBannerRow">
                    <v-divider :thickness="15" vertical></v-divider>
                    <v-col cols="4">
                        <v-row md="11" cols="12" class="registeredBannerRow">
                            <span>{{ 'Cadastrados' | translate('Aviso') }}</span>
                        </v-row>
                        <v-row >
                            <v-col cols="8">
                                <v-text-field
                                    readonly
                                    v-model="registeredBanner.name"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row style="">
                            <v-col cols="6">
                                <v-card>
                                    <div style="display:flex;justify-content:flex-end;">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        style="cursor:pointer;"
                                                        color="red"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="deleteBanner()"
                                                    >
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
                                            <span>Deletar banner</span>
                                        </v-tooltip>
                                    </div>
                                    <img class="img" :src="this.baseUrl + this.registeredBanner.url + this.registeredBanner.name">
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-divider :thickness="15" vertical></v-divider>
                    <v-col cols="6">
                        <v-row md="12" cols="12">
                            <v-col cols="12">
                                <span>{{ 'Destinatário' | translate('Aviso') }}</span>
                            </v-col>
                        </v-row>
                        <v-row md="12" cols="12">
                            <v-col cols="6">
                                <v-list>
                                    <v-subheader>{{ 'Quem irá visualizar esse banner?' | translate('Aviso') }}</v-subheader>
                                    <v-list-item>
                                        <v-checkbox
                                            v-model="registeredBanner.operator"
                                            :label="'Operadores' | translate('Aviso')"
                                        >
                                        </v-checkbox>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-checkbox
                                            v-model="registeredBanner.client"
                                            :label="'Clientes' | translate('Aviso')"
                                        >
                                        </v-checkbox>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                            <v-col cols="6">
                                <v-list>
                                    <v-subheader>{{ 'Qual nível de acesso o destinatário precisa ter?' | translate('Aviso') }}</v-subheader>
                                    <v-list-item>
                                        <v-checkbox
                                            v-model="registeredBanner.administrator"
                                            :label="'Administrador' | translate('Aviso')"
                                        >
                                        </v-checkbox>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-checkbox
                                            v-model="registeredBanner.nonAdministrator"
                                            :label="'Não-Administrador' | translate('Aviso')"
                                        >
                                        </v-checkbox>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-col>
                </div>
                <v-row style="display:flex; justify-content:flex-end; padding:5px;">
                    <v-btn dark class="btn1" @click="updateBannerInfo()"> 
                        <v-icon x-small>mdi-check</v-icon>
                        <span style="margin-left: 4px;">{{'Salvar' | translate('Aviso')}}</span>
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import addBanner from '../../../src/app/aviso/addBanner'
import updateBannerInformation from '../../../src/app/aviso/updateBannerInformation'
import removeBanner from '../../../src/app/aviso/removeBanner.js'
import insertWarning from '../../../src/app/aviso/insertWarning'
import newBanner from '../../../src/app/file/upload'
import { createNamespacedHelpers } from 'vuex'
import translate from '../../../src/plugins/translate'
import loadWarning from '../../../src/app/aviso/loadWarning'
const user = createNamespacedHelpers('user')
const warning = createNamespacedHelpers('warning')

export default {
    name: 'Aviso',
    data() {
        return {
            loading : false,
            labels : {
                aviso : translate('Digite o Aviso', 'Aviso'),
                banner : translate('Importe o banner', 'Aviso')
            },
            registeredBanner : {},
            defaultBanner : {},
            newBanner : null,
            warnings : [],
            baseUrl: process.env.VUE_APP_API_URL,
        }
    },

    methods: {
        ...warning.mapGetters(['getStoreWarning']),
        async save(){
            this.loading = true
            for(const w of this.warnings) w.EMPRESA_ID = this.user.EMPRESA_ID
            const param = this.warnings.length
                ? this.warnings
                : [{EMPRESA_ID: this.user.EMPRESA_ID}]
            await insertWarning(param)
            this.loading = false
        },
        async updateBannerInfo(){
            if(this.bannerChanged) return
            this.loading = true
            await updateBannerInformation({banner : this.registeredBanner, companyId : this.user.EMPRESA_ID, userId: this.user.USUARIO_ID})
                .then((response) => {
                    this.registeredBanner = response.data.banner
                    this.defaultBanner = Object.assign({}, response.data.banner)
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                })
        },
        async deleteBanner(){
            this.loading = true
            await removeBanner({banner : this.registeredBanner, userId: this.user.USUARIO_ID}).then(() => {
                window.location.reload()
                this.loading = false
            })
        }
        ,
        addWarning(){
            this.$store.dispatch('warning/setWarning', this.warnings.concat([{position : this.warnings.length - 1}]))
            this.warnings = this.getStoreWarning()
        },
        deleteWarning(position){
            this.$store.dispatch('warning/setWarning', this.warnings.filter(w => w.position != position))
            this.warnings = this.getStoreWarning()
        },
        async uploadBanner(){
            if(this.registeredBanner.name){
                await removeBanner({name : this.registeredBanner.name})
            }
            this.loading = true
            var formData = new FormData()
            var filename = 'banner.' + this.newBanner.name.slice(this.newBanner.name.lastIndexOf(".") + 1)
            await addBanner({name : filename, companyId : this.user.EMPRESA_ID, userId: this.user.USUARIO_ID})
            formData.append('image', this.newBanner, filename)
            await newBanner({directory: 'img/banner'}, formData).then(() => {
                this.newBanner = null
                window.location.reload()
            })
        }
        ,
        async getData(){
            this.loading = true
            await loadWarning(this.user.EMPRESA_ID, this.user.USUARIO_ID)
                .then(function(response){
                    this.$store.dispatch('warning/setWarning', response.data.warning)
                    this.registeredBanner = response.data.banner
                    this.defaultBanner = Object.assign({}, response.data.banner)
                    this.warnings = this.getStoreWarning()
                    this.loading = false
                }.bind(this))
        },
    },
    computed:{
        ...user.mapGetters(['user']),
        bannerChanged(){
            return JSON.stringify(this.registeredBanner) == JSON.stringify(this.defaultBanner)
        }
    },
    async mounted(){
        await this.getData()
    }
}
</script>
<style scoped>
.cards{
    margin-top:10px;
    margin-bottom:25px;
}
.btn1{
    text-transform: none !important;
}
.headerPage{
    height: 2rem;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.headline{
    font-size: 14px !important;
}
.rowPadding{
    justify-content: center;
}
.scrollList{
    overflow-y: auto;
    overflow-x: hidden;
    height: 84%;
    max-height: 84%;
}
.scrollList::-webkit-scrollbar {
    width: 8px;
}

.scrollList::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.scrollList::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.cardSide{
    height: 560px;
}
.registeredBannerRow{
    padding-left:20px;
}
.img{
    max-width : 250px;
    max-height : 280px;
}
</style>
